import React, { useState, useEffect, useContext } from "react";
import {
	Box,
	Typography,
	Button,
	Avatar,
	Grid,
	Divider,
	IconButton,
	Tab,
	Tabs,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ServiceTrainer1 from "../../assets/showcases/trainer/service1.jpg";
import ServiceTrainer2 from "../../assets/showcases/trainer/service2.jpg";
import ServiceTrainer3 from "../../assets/showcases/trainer/service3.jpg";
import Service4 from "../../assets/showcases/salon/service3.jpeg";
import ServiceBarber4 from "../../assets/showcases/barber/service4.jpg";
import ServiceBarber1 from "../../assets/showcases/barber/service1.jpg";
import ServiceBarber3 from "../../assets/showcases/barber/service3.jpg";
import {
	CalendarOutline,
	TimeOutline,
	PersonOutline,
	TrashOutline,
} from "react-ionicons";
import { CreatorContext } from "../../context/CreatorContext";
import chroma from "chroma-js";

const ShowcaseBookings = ({
	sector,
	appointment,
	showAllIcons,
	cardBackgroundColor,
	showShadow,
	showIcon,
	showImage,
	showCard,
	backgroundColor,
	tabStyle,
}) => {
	const { t } = useTranslation();
	const [content, setContent] = useState([]);
	const { creator } = useContext(CreatorContext);

	const getTextColorBasedOnBackground = (bgColor) => {
		const r = parseInt(bgColor.substring(1, 3), 16);
		const g = parseInt(bgColor.substring(3, 5), 16);
		const b = parseInt(bgColor.substring(5, 7), 16);
		const brightness = (r * 299 + g * 587 + b * 114) / 1000;
		return brightness > 128 ? "#000000" : "#FFF";
	};

	console.log(appointment);
	const AppointmentTabs = () => {
		return (
			<Box sx={{ width: "100%" }}>
				<Grid container spacing={0} sx={{ textAlign: "center" }}>
					<Grid
						item
						xs={6}
						sx={{
							cursor: "pointer",
							padding: "8px 0",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: tabStyle === "tabStyle1" ? "inherit" : creator.color,
								marginBottom: tabStyle === "tabStyle1" ? 0.5 : 0,
							}}
						>
							{t("appointments.current")}
						</Typography>
						<Box
							sx={{
								borderBottom:
									tabStyle === "tabStyle1"
										? `1px solid ${creator.color}`
										: "none",
							}}
						></Box>
					</Grid>
					<Grid
						item
						xs={6}
						sx={{
							cursor: "pointer",
							padding: "8px 0",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: "#888",
							}}
						>
							{t("appointments.past")}
						</Typography>
					</Grid>
				</Grid>
			</Box>
		);
	};

	useEffect(() => {
		const loadContent = () => {
			switch (sector) {
				case "barber":
					return [
						{
							service: t("homeServices.haircut"),
							staff: "John",
							date: "21 Oct 2024",
							time: "11:00h",
							price: "€20.00",
							image: ServiceBarber4,
						},
						{
							service: t("homeServices.beardTrim"),
							staff: "Mark",
							date: "23 Oct 2024",
							time: "14:00h",
							price: "€15.00",
							image: ServiceBarber1,
						},
						{
							service: t("homeServices.styling"),
							staff: "John",
							date: "25 Oct 2024",
							time: "16:00h",
							price: "€30.00",
							image: ServiceBarber3,
						},
					];

				case "salon":
					return [
						{
							service: t("homeServices.facialCleansing"),
							staff: "Ann",
							date: "29 Oct 2024",
							time: "14:00h",
							price: "€30.00",
							image: Service4,
						},
						{
							service: t("homeServices.nailPolish"),
							staff: "Ann",
							date: "02 Oct 2024",
							time: "10:00h",
							price: "€18.00",
							image: Service4,
						},
						{
							service: t("homeServices.shellacManicure"),
							staff: "Ann",
							date: "13 Oct 2024",
							time: "10:00h",
							price: "€24.00",
							image: Service4,
						},
					];

				case "trainer":
					return [
						{
							service: t("homeServices.personalTraining"),
							staff: "Chris",
							date: "01 Oct 2024",
							time: "12:00h",
							price: "€50.00",
							image: ServiceTrainer1,
						},
						{
							service: t("homeServices.onlineTraining"),
							staff: "Alex",
							date: "05 Oct 2024",
							time: "15:00h",
							price: "€30.00",
							image: ServiceTrainer2,
						},
						{
							service: t("homeServices.nutritionConsultation"),
							staff: "Chris",
							date: "08 Oct 2024",
							time: "09:00h",
							price: "€40.00",
							image: ServiceTrainer3,
						},
					];

				default:
					return [];
			}
		};

		setContent(loadContent());
	}, [sector, t]);

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				padding: 1,
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			<AppointmentTabs />
			{content &&
				appointment === "appointment6" &&
				content.map((appointment, index) => (
					<Box sx={{ padding: 0.5 }}>
						<Box
							sx={{
								backgroundColor: cardBackgroundColor || "#ffffff",
								color: getTextColorBasedOnBackground(
									cardBackgroundColor || "#ffffff"
								),
								padding: 1,
								borderRadius: "0px",
								boxShadow: showShadow
									? "0px 2px 8px rgba(0, 0, 0, 0.05)"
									: "none",
								display: "flex",
								flexDirection: "row",
								gap: showImage ? 1.5 : 0,
								flex: 1,
							}}
						>
							<Box>
								{showImage && (
									<Avatar
										src={appointment.image}
										alt={appointment.service}
										variant="square"
										sx={{
											width: "50px",
											height: "50px",
											aspectRatio: 1,
											objectFit: "cover",
										}}
									/>
								)}
							</Box>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									flex: 1,
								}}
							>
								<Typography variant="body1" sx={{ fontSize: "8px" }}>
									{appointment.service}
								</Typography>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										fontSize: "8px",
									}}
								>
									{showAllIcons && (
										<CalendarOutline
											height="7px"
											width="7px"
											color={getTextColorBasedOnBackground(
												cardBackgroundColor || "#ffffff"
											)}
										/>
									)}
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{appointment.date}
									</Typography>
								</Box>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										fontSize: "8px",
									}}
								>
									{showAllIcons && (
										<TimeOutline
											height="7px"
											width="7px"
											color={getTextColorBasedOnBackground(
												cardBackgroundColor || "#ffffff"
											)}
										/>
									)}
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{appointment.time}
									</Typography>
								</Box>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										fontSize: "8px",
									}}
								>
									{showAllIcons && (
										<PersonOutline
											height="7px"
											width="7px"
											color={getTextColorBasedOnBackground(
												cardBackgroundColor || "#ffffff"
											)}
										/>
									)}
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{t("bookingConfirmation.with")} {appointment.staff}
									</Typography>
								</Box>
								<Box
									sx={{
										display: "flex",
										flexDirection: "row",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Typography
										variant="body2"
										sx={{ fontWeight: "bold", fontSize: "8px" }}
									>
										{appointment.price}
									</Typography>
									<Box>
										{showIcon ? (
											<TrashOutline
												height="7px!important"
												width="7px!important"
												color={creator.color}
											/>
										) : (
											<Typography
												variant="body2"
												sx={{ fontSize: "8px", color: creator.color }}
											>
												{t("appointments.cancel")}
											</Typography>
										)}
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				))}
			{content &&
				appointment === "appointment5" &&
				content.map((appointment, index) => (
					<Box sx={{ padding: 0.5 }}>
						<Box
							sx={{
								backgroundColor: cardBackgroundColor || "#ffffff",
								color: getTextColorBasedOnBackground(
									cardBackgroundColor || "#ffffff"
								),
								boxShadow: showShadow
									? "0px 2px 8px rgba(0, 0, 0, 0.05)"
									: "none",
								display: "flex",
								flexDirection: "column",
							}}
						>
							<Box sx={{ position: "relative" }}>
								<Avatar
									src={appointment.image}
									alt={appointment.service}
									variant="square"
									sx={{
										width: "100%",
										height: "70px",
										objectFit: "cover",
									}}
								/>
								<Box
									sx={{
										position: "absolute",
										bottom: 0,
										left: 0,
										width: "100%",
										color: "#ffffff",
										padding: "4px 8px",
										display: "flex",
										alignItems: "center",
										justifyContent: "flex-start",
									}}
								>
									<Typography
										variant="body2"
										sx={{
											fontSize: "12px",
											textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
										}}
									>
										{appointment.service}
									</Typography>
								</Box>
							</Box>

							<Box sx={{ padding: 1 }}>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										fontSize: "8px",
									}}
								>
									{showAllIcons && (
										<CalendarOutline
											height="7px"
											width="7px"
											color={getTextColorBasedOnBackground(
												cardBackgroundColor || "#ffffff"
											)}
										/>
									)}
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{appointment.date}
									</Typography>
								</Box>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										fontSize: "8px",
									}}
								>
									{showAllIcons && (
										<TimeOutline
											height="7px"
											width="7px"
											color={getTextColorBasedOnBackground(
												cardBackgroundColor || "#ffffff"
											)}
										/>
									)}
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{appointment.time}
									</Typography>
								</Box>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										fontSize: "8px",
									}}
								>
									{showAllIcons && (
										<PersonOutline
											height="7px"
											width="7px"
											color={getTextColorBasedOnBackground(
												cardBackgroundColor || "#ffffff"
											)}
										/>
									)}
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{t("bookingConfirmation.with")} {appointment.staff}
									</Typography>
								</Box>

								<Box
									sx={{
										display: "flex",
										flexDirection: "row",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Typography
										variant="body2"
										sx={{ fontWeight: "bold", fontSize: "8px" }}
									>
										{appointment.price}
									</Typography>
									<Box>
										{showIcon ? (
											<TrashOutline
												height="7px!important"
												width="7px!important"
												color={creator.color}
											/>
										) : (
											<Typography
												variant="body2"
												sx={{ fontSize: "8px", color: creator.color }}
											>
												{t("appointments.cancel")}
											</Typography>
										)}
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				))}

			{content && appointment === "appointment1" && (
				<Box
					sx={{
						padding: 0.5,
						display: "flex",
						flexDirection: "column",
					}}
				>
					{content.map((appointment, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								flexDirection: "column",
								borderRadius: "8px",
								backgroundColor: showCard ? backgroundColor : "inherit",
								color: showCard
									? getTextColorBasedOnBackground(backgroundColor)
									: "inherit",
								padding: showCard ? 1 : 0,
								marginBottom: showCard ? 1 : 0,
							}}
						>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography
									variant="body1"
									sx={{ fontWeight: "bold", fontSize: "8px" }}
								>
									{appointment.service}
								</Typography>
								<Typography
									variant="body2"
									sx={{ fontWeight: "bold", fontSize: "8px" }}
								>
									{appointment.price}
								</Typography>
							</Box>

							<Box>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										fontSize: "8px",
									}}
								>
									{showAllIcons && (
										<CalendarOutline
											height="7px"
											width="7px"
											color={
												creator.themeMode === "Dark" ? "#ffffff" : "#000000"
											}
										/>
									)}
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{appointment.date}
									</Typography>
								</Box>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										fontSize: "8px",
									}}
								>
									{showAllIcons && (
										<TimeOutline
											height="7px"
											width="7px"
											color={
												creator.themeMode === "Dark" ? "#ffffff" : "#000000"
											}
										/>
									)}
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{appointment.time}
									</Typography>
								</Box>

								<Box
									sx={{
										display: "flex",
										flexDirection: "row",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{t("bookingConfirmation.with")} {appointment.staff}
									</Typography>
									<Box>
										{showIcon ? (
											<TrashOutline
												height="7px!important"
												width="7px!important"
												color={creator.color}
											/>
										) : (
											<Typography
												variant="body2"
												sx={{ fontSize: "8px", color: creator.color }}
											>
												{t("appointments.cancel")}
											</Typography>
										)}
									</Box>
								</Box>
							</Box>
							{!showCard && (
								<Divider
									sx={{
										marginTop: 1,
										marginBottom: 1,
										borderColor:
											creator.themeMode === "Dark"
												? chroma(creator.themeColor).brighten(1).hex()
												: chroma(creator.themeColor).darken(0.5).hex(),
									}}
								/>
							)}
						</Box>
					))}
				</Box>
			)}

			{content && appointment === "appointment2" && (
				<Box
					sx={{
						padding: 0.5,
						display: "flex",
						flexDirection: "column",
					}}
				>
					{content.map((appointment, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								flexDirection: "column",
								borderRadius: "8px",
								backgroundColor: showCard ? backgroundColor : "inherit",
								color: showCard
									? getTextColorBasedOnBackground(backgroundColor)
									: "inherit",
								padding: showCard ? 1 : 0,
								marginBottom: showCard ? 1 : 0,
							}}
						>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Box
									sx={{
										display: "flex",
										flexDirection: "row",
										gap: 1,
									}}
								>
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											gap: 0.5,
											fontSize: "8px",
										}}
									>
										{showAllIcons && (
											<CalendarOutline
												height="7px"
												width="7px"
												color={
													creator.themeMode === "Dark" ? "#ffffff" : "#000000"
												}
											/>
										)}
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{appointment.date}
										</Typography>
									</Box>
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											gap: 0.5,
											fontSize: "8px",
										}}
									>
										{showAllIcons && (
											<TimeOutline
												height="7px"
												width="7px"
												color={
													creator.themeMode === "Dark" ? "#ffffff" : "#000000"
												}
											/>
										)}
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{appointment.time}
										</Typography>
									</Box>
								</Box>
								<Typography
									variant="body2"
									sx={{ fontWeight: "bold", fontSize: "8px" }}
								>
									{appointment.price}
								</Typography>
							</Box>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography
									variant="body1"
									sx={{
										fontWeight: "bold",
										fontSize: "10px",
										marginBottom: 0.5,
									}}
								>
									{appointment.service}
								</Typography>
							</Box>

							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography variant="body2" sx={{ fontSize: "8px" }}>
									{t("bookingConfirmation.with")} {appointment.staff}
								</Typography>
								<Box>
									{showIcon ? (
										<TrashOutline
											height="7px!important"
											width="7px!important"
											color={creator.color}
										/>
									) : (
										<Typography
											variant="body2"
											sx={{ fontSize: "8px", color: creator.color }}
										>
											{t("appointments.cancel")}
										</Typography>
									)}
								</Box>
							</Box>
							{!showCard && (
								<Divider
									sx={{
										marginTop: 1,
										marginBottom: 1,
										borderColor:
											creator.themeMode === "Dark"
												? chroma(creator.themeColor).brighten(1).hex()
												: chroma(creator.themeColor).darken(0.5).hex(),
									}}
								/>
							)}
						</Box>
					))}
				</Box>
			)}

			{content && appointment === "appointment3" && (
				<Box
					sx={{
						padding: 0.5,
						display: "flex",
						flexDirection: "column",
					}}
				>
					{content.map((appointment, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								flexDirection: "column",
								borderRadius: "8px",
								backgroundColor: showCard ? backgroundColor : "inherit",
								color: showCard
									? getTextColorBasedOnBackground(backgroundColor)
									: "inherit",
								padding: showCard ? 1 : 0,
								marginBottom: showCard ? 1 : 0,
							}}
						>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-around",
									alignItems: "center",
									flex: 1,
									gap: 1,
								}}
							>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										fontSize: "8px",
										flexDirection: "column",
									}}
								>
									<CalendarOutline
										height="10px"
										width="10px"
										color={
											showCard &&
											getTextColorBasedOnBackground(
												backgroundColor || "#ffffff"
											)
										}
									/>

									<Typography
										variant="body2"
										sx={{ fontSize: "7px", fontWeight: "bold" }}
									>
										{appointment.date}
									</Typography>
									<Typography variant="body2" sx={{ fontSize: "7px" }}>
										{appointment.time}
									</Typography>
								</Box>
								<Typography
									variant="body1"
									sx={{
										fontSize: "10px",
										marginBottom: 0.5,
										flex: 1,
										textAlign: "left",
									}}
								>
									{appointment.service}
								</Typography>
								<Box
									sx={{
										display: "flex",
										justifyContent: "flex-end",
										flexDirection: "column",
									}}
								>
									<Typography
										variant="body2"
										sx={{
											fontWeight: "bold",
											fontSize: "8px",
											textAlign: "right",
										}}
									>
										{appointment.price}
									</Typography>
									<Box>
										{showIcon ? (
											<TrashOutline
												height="7px!important"
												width="7px!important"
												color={creator.color}
											/>
										) : (
											<Typography
												variant="body2"
												sx={{ fontSize: "8px", color: creator.color }}
											>
												{t("appointments.cancel")}
											</Typography>
										)}
									</Box>
								</Box>
							</Box>

							{!showCard && (
								<Divider
									sx={{
										marginTop: 1,
										marginBottom: 1,
										borderColor:
											creator.themeMode === "Dark"
												? chroma(creator.themeColor).brighten(1).hex()
												: chroma(creator.themeColor).darken(0.5).hex(),
									}}
								/>
							)}
						</Box>
					))}
				</Box>
			)}

			{content && appointment === "appointment4" && (
				<Box
					sx={{
						padding: 0.5,
						display: "flex",
						flexDirection: "column",
					}}
				>
					{content.map((appointment, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								flexDirection: "column",
								borderRadius: "8px",
								backgroundColor: showCard ? backgroundColor : "inherit",
								color: showCard
									? getTextColorBasedOnBackground(backgroundColor)
									: "inherit",
								padding: showCard ? 1 : 0,
								marginBottom: showCard ? 1 : 0,
							}}
						>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography
									variant="body1"
									sx={{
										fontWeight: "bold",
										fontSize: "8px",
									}}
								>
									{appointment.service}
								</Typography>
								<Typography
									variant="body2"
									sx={{ fontWeight: "bold", fontSize: "8px" }}
								>
									{appointment.price}
								</Typography>
							</Box>

							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									gap: 1,
								}}
							>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										fontSize: "8px",
									}}
								>
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{appointment.date} - {appointment.time}
									</Typography>
								</Box>
							</Box>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography variant="body2" sx={{ fontSize: "8px" }}>
									{t("bookingConfirmation.with")} {appointment.staff}
								</Typography>
								<Box>
									{showIcon ? (
										<TrashOutline
											height="7px!important"
											width="7px!important"
											color={creator.color}
										/>
									) : (
										<Typography
											variant="body2"
											sx={{ fontSize: "8px", color: creator.color }}
										>
											{t("appointments.cancel")}
										</Typography>
									)}
								</Box>
							</Box>
							{!showCard && (
								<Divider
									sx={{
										marginTop: 1,
										marginBottom: 1,
										borderColor:
											creator.themeMode === "Dark"
												? chroma(creator.themeColor).brighten(1).hex()
												: chroma(creator.themeColor).darken(0.5).hex(),
									}}
								/>
							)}
						</Box>
					))}
				</Box>
			)}
		</Box>
	);
};

export default ShowcaseBookings;
